var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle214(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "276.4399708700209 496.7068445594716 18.192364159952888 18.033927175666577",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M283.95,500.72c2.7.13,6.05,2.9,6.6,5.46.55,2.57-1.74,4.94-4.35,4.51-2.61-.43-5.54-3.64-5.75-6.32-.16-1.9,1.62-3.75,3.51-3.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle214);
export default __webpack_public_path__ + "static/media/twinkle-2-14.a6110f688b7080ebe7fc8e00a1796c4c.svg";
export { ForwardRef as ReactComponent };